/** declare only http service related requests */

import { HttpTokens, GetProfileMyIncidentList } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description Get incident data that relates to currently logged-in user, we use user token to match to current user
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const ProfileMyIncidentGet = (
  prefix: string = 'employees/profile/my-incident',
  employeeId: string,
  tokens: HttpTokens,
  hardRejection = true
): Promise<GetProfileMyIncidentList> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .get(`${prefix}/${employeeId}`, config)
    .then((d: AxiosResponse<GetProfileMyIncidentList>) => {
      // return Promise.reject(new Error('ups')) as any;
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<GetProfileMyIncidentList>;
};
